import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { addCertification, deleteCertification, fetchCertifications, updateCertification } from "./CertificationsAPI";


const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const fetchCertificationsAsync = createAsyncThunk(
  "certifications/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const data = await fetchCertifications();

      const resp = data.response;
      // console.log("data's response", data.response)
      return resp;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteCertificateAsync = createAsyncThunk(
  "certifications/delete",
  async ({uuid}, { rejectWithValue }) => {
    try {
      await deleteCertification(uuid);
      return uuid;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateCertificationAsync = createAsyncThunk(
  "certifications/update",
  async ({ uuid, certificateData }, { rejectWithValue }) => {
    try {
      const response = await updateCertification( uuid, certificateData);
      // console.log("Response Slice", response);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const addCertificationsAsync = createAsyncThunk(
  "certifications/add",
  async ({ newCertification}) => {
    try {
      const data = await addCertification( newCertification);
      // console.log("data in slice", data);
      return data;
    } catch (error) {
      console.log("errorL :", error);
      // return rejectWithValue(error.message);
    }
  }
);

const certificationSlice = createSlice({
  name: "Certifications",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCertificationsAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCertificationsAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // console.log("DAta", action.payload)
        state.error = null;
      })
      .addCase(fetchCertificationsAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })
      .addCase(addCertificationsAsync.fulfilled, (state, action) => {
        state.loading = false;
        if (Array.isArray(state.data)) {
          state.data?.push(action.payload);
        } else {
          state.data = [action.payload]; // Initialize as an array if it's not already
        }
      })
      .addCase(addCertificationsAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message || "Failed to add project";
      })

      .addCase(updateCertificationAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCertificationAsync.fulfilled, (state, action) => {
        state.loading = false;
      
        if (Array.isArray(state.data)) {
          const updatedProjectIndex = state.data.findIndex(
            (projectData) => projectData.uuid === action.payload.uuid
          );
      
          if (updatedProjectIndex !== -1) {
            state.data[updatedProjectIndex] = action.payload;
          }
        } else {
          state.data = [action.payload]; // Fallback: set the state to an array with the updated project
        }
      })
      
      .addCase(updateCertificationAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message || "Failed to update project";
      })
      
      .addCase(deleteCertificateAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteCertificateAsync.fulfilled, (state, action) => {
        state.loading = false;
        // Ensure state.data is an array before filtering
        if (Array.isArray(state.data)) {
          state.data = state.data.filter((certificate) => certificate.uuid !== action.payload);
        } else {
          console.error("state.data is not an array");
        }
      })
      .addCase(deleteCertificateAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const selectCertifications = (state) => state.certifications?.data?.certifications;

export default certificationSlice.reducer;
